module.exports = __webpack_public_path__ + "img/FR18089.7306688f.png";